// components/MonthCalendar.jsx

import React, { useMemo } from "react";
import { FaArrowsAltH } from "react-icons/fa";

import CalendarDayCell from "./CalendarDayCell";

import {
  buildEventsByDate,
  buildMonthGridDays,
  toDateKey,
  WEEK_DAYS,
} from "../utils/calendarUtils";

export default function MonthCalendar({
  monthDate,
  events = [],
  onSelectEvent,
  onOpenDay,
}) {
  const days = useMemo(
    () => buildMonthGridDays(monthDate),
    [monthDate]
  );

  const eventsByDate = useMemo(
    () => buildEventsByDate(events, days),
    [events, days]
  );

  return (
    <div>
      <div className="mb-2 flex items-center justify-center gap-2 rounded-xl border border-blue-100 bg-blue-50 px-3 py-2 text-[11px] font-bold text-blue-700 dark:border-blue-900/50 dark:bg-blue-950/30 dark:text-blue-300 lg:hidden">
        <FaArrowsAltH />
        Faites glisser horizontalement pour consulter
        toute la semaine
      </div>

      <div className="overflow-x-auto pb-3">
        <div
          className={[
            "min-w-[1050px] overflow-hidden rounded-[1.75rem]",
            "border border-slate-200 bg-white",
            "shadow-[0_20px_60px_rgba(15,23,42,0.08)]",
            "dark:border-white/10 dark:bg-slate-900",
            "dark:shadow-[0_25px_70px_rgba(0,0,0,0.35)]",
          ].join(" ")}
        >
          <div className="grid grid-cols-7 border-b border-slate-200 bg-slate-950 text-white dark:border-white/10">
            {WEEK_DAYS.map((day) => (
              <div
                key={day}
                className={[
                  "border-r border-white/10 px-3 py-3 text-center",
                  "text-[11px] font-black uppercase tracking-[0.14em]",
                  "last:border-r-0",
                ].join(" ")}
              >
                {day}
              </div>
            ))}
          </div>

          <div className="grid grid-cols-7 border-l border-t border-slate-200 dark:border-white/10">
            {days.map((date) => {
              const dateKey = toDateKey(date);

              return (
                <CalendarDayCell
                  key={dateKey}
                  date={date}
                  monthDate={monthDate}
                  events={
                    eventsByDate[dateKey] || []
                  }
                  onSelectEvent={onSelectEvent}
                  onOpenDay={onOpenDay}
                />
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}